const CareRelatedInformation = () => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 9C0 4.02944 4.02944 0 9 0H31C35.9706 0 40 4.02944 40 9V31C40 35.9706 35.9706 40 31 40H9C4.02944 40 0 35.9706 0 31V9Z"
      fill="#82D893"
    />
    <g clipPath="url(#clip0_2944_12501)">
      <path
        d="M19.9998 10.4167C14.7082 10.4167 10.4165 14.7084 10.4165 20.0001C10.4165 25.2917 14.7082 29.5834 19.9998 29.5834C25.2915 29.5834 29.5832 25.2917 29.5832 20.0001C29.5832 14.7084 25.2915 10.4167 19.9998 10.4167ZM25.4165 21.6667C25.4165 21.9167 25.2498 22.0834 24.9998 22.0834H22.0832V25.0001C22.0832 25.2501 21.9165 25.4167 21.6665 25.4167H18.3332C18.0832 25.4167 17.9165 25.2501 17.9165 25.0001V22.0834H14.9998C14.7498 22.0834 14.5832 21.9167 14.5832 21.6667V18.3334C14.5832 18.0834 14.7498 17.9167 14.9998 17.9167H17.9165V15.0001C17.9165 14.7501 18.0832 14.5834 18.3332 14.5834H21.6665C21.9165 14.5834 22.0832 14.7501 22.0832 15.0001V17.9167H24.9998C25.2498 17.9167 25.4165 18.0834 25.4165 18.3334V21.6667Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_2944_12501">
        <rect
          width="20"
          height="20"
          fill="white"
          transform="translate(10 10)"
        />
      </clipPath>
    </defs>
  </svg>
)

export default CareRelatedInformation
